module.exports = __webpack_public_path__ + "img/_DSC6719.f1454a21.jpg";